module.exports = __webpack_public_path__ + "images/rss.jpg";


//////////////////
// WEBPACK FOOTER
// ./vively/images/social-media-icons/rss.jpg
// module id = 875
// module chunks = 3